export function getdata() {
	var obj = {
		headData: [{
				title: "序号",
				prop: 'hanh',
				width: "100px",
				fixed: 'left'
			}, {
				title: '税目',
				prop: "ccxwyh_3_x_6",
				Required: true,
				custom: true,
				width: "200px",
				fixed: 'left'

			}, {
				title: '子目',
				prop: "ccxwyh_3_x_7",
				custom: true,
				width: "200px",
				fixed: 'left'

			},
			{
				title: "应税凭证税务编号",
				prop: "ccxwyh_3_x_1",
				custom: true,

				width: "200px",
			},
			{
				title: "应税凭证编号",
				prop: "ccxwyh_3_x_2",
				custom: true,
				width: "200px",


			},
			{
				title: '应税凭证名称',
				prop: "ccxwyh_3_x_3",
				custom: true,
				Required: true,
				width: "200px"
			},
			{
				title: '申报期限类型',
				prop: "ccxwyh_3_x_4",
				custom: true,
				Required: true,
				width: "200px"
			},
			{
				title: '应税凭证数量',
				prop: "ccxwyh_3_x_5",
				custom: true,

				width: "200px"
			}, {
				title: '税款所属期起',
				prop: "ccxwyh_3_x_8",
				Required: true,
				custom: true,
				width: "200px",
			}, {
				title: '税款所属期止',
				prop: "ccxwyh_3_x_9",
				Required: true,
				custom: true,
				width: "200px",
			}, {
				title: '应税凭证书立日期',
				prop: "ccxwyh_3_x_10",
				Required: true,
				custom: true,
				width: "200px",
			}, {
				title: '计税金额',
				prop: "ccxwyh_3_x_11",
				Required: true,

				custom: true,
				width: "200px",
			}, {
				title: '实际结算日期',
				prop: "ccxwyh_3_x_12",
				custom: true,
				width: "200px",
			}, {
				title: '实际结算金额',
				prop: "ccxwyh_3_x_13",

				custom: true,
				width: "200px",
			}, {
				title: '税率',
				prop: "ccxwyh_3_x_14",
				custom: true,

				Required: true,
				width: "200px",
			}, {
				title: '减免性质代码和项目名称',
				prop: "ccxwyh_3_x_15",
				custom: true,
				width: "200px",
			}, {
				title: '应纳税额',
				prop: "ccxwyh_3_x_16",

				custom: true,
				width: "200px",
			}, {
				title: '核定比例',
				prop: "ccxwyh_3_x_17",

				custom: true,
				width: "200px",
			}, {
				title: '减免税额',
				prop: "ccxwyh_3_x_18",

				custom: true,
				width: "200px",
			}, {
				title: '已交税额',
				prop: "ccxwyh_3_x_19",

				custom: true,
				width: "200px",
			}, {
				title: '对方书立人信息',
				children: [{
					title: '对方书立人名称',
					prop: "cz1",
					custom: true,
					width: "200px",
					fixed: "right"
				}, {
					title: '对方书立人纳税人识别号（统一社会信用代码）',
					prop: "cz2",
					custom: true,
					width: "200px",
					fixed: "right"
				}, {
					title: '对方书立人涉及金额',
					prop: "cz3",
					custom: true,
					width: "200px",
				}],
			}
		],
		headDatadls: [{
			title: '对方书立人名称',
			prop: "prop1",
			custom: true,
			width: "200px",
		}, {
			title: '对方书立人纳税人识别号（统一社会信用代码）',
			prop: "prop2",
			custom: true,
			width: "200px",
		}, {
			title: '对方书立人涉及金额',
			prop: "prop3",
			custom: true,
			width: "200px",
		}],
		tableData: [

		],
		//页码
		pagination: {
			pageNum: 1,
			pageSize: 50,
			total: 3,
			paginationkey: 0
		},
	}
	return obj
}